/**
 * This works with both Budget's old and new structure.
 * @param {Object} budget Object with values.
 * @returns {boolean} `true` if permanently saved (i.e. is sent); `false` if temporarily saved.
 */
export function verifyIfBudgetIsSent(budget) {
  if (!budget) return false

  if (budget?.proposeOpened === false && budget?.released === true) return true
  if (budget?.proposeOpened === true && budget?.diagnosis?.length > 0) return true
  // change this verifications for the field 'sent' to be created on budget
  return false
}
